import React from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Paper,
} from "@mui/material";

/**
 * Server Page Component to show a summary card of service providers with sites
 * @param {*} param0 
 * @returns 
 */
const ServiceProviderComponent = ({ providers, isFetching }) => {  
  if (isFetching) {
    return <div>Loading...</div>;
  }

  if (!providers || providers.length === 0) {
    return <div>No providers found.</div>;
  }

  return (
    <Box display="flex" flexWrap="wrap" gap={2} p={1}>
      {providers.map((provider) => (
        <Paper
          key={provider.providerId}
          elevation={1}
          sx={{
            p: 1,
            minWidth: 140,
            borderRadius: 2,
            backgroundColor: "#f9fafb", // light gray
          }}
        >
          <Typography variant="subtitle2" gutterBottom>
            {provider.name}
          </Typography>
          <List dense disablePadding>
            {provider.sites.length > 0 ? (
              provider.sites.map((site) => (
                <ListItem key={site.siteId} dense disablePadding>
                  <ListItemText
                    primaryTypographyProps={{ variant: "caption" }}
                    primary={site.name}
                  />
                </ListItem>
              ))
            ) : (
              <ListItem dense disablePadding>
                <ListItemText
                  primaryTypographyProps={{
                    variant: "caption",
                    color: "text.secondary",
                    fontStyle: "italic",
                  }}
                  primary="No sites"
                />
              </ListItem>
            )}
          </List>
        </Paper>
      ))}
    </Box>
  );
};

export default ServiceProviderComponent;

// Example data to use for testing the component
const exampleData = [
  {
    name: "provideri",
    providerId: 1,
    sites: [
      { name: "saitti", siteId: 1, id: 1 },
      { name: "saitti", siteId: 1, id: 1 },
      { name: "saitti", siteId: 1, id: 1 },
      { name: "saitti", siteId: 1, id: 1 },
      { name: "saitti", siteId: 1, id: 1 },
      { name: "saitti", siteId: 1, id: 1 },
    ],
  },
  {
    name: "provideri2",
    providerId: 2,
    sites: [
      { name: "saitti", siteId: 1, id: 1 },
      { name: "saitti", siteId: 1, id: 1 },
      { name: "saitti", siteId: 1, id: 1 },
      { name: "saitti", siteId: 1, id: 1 },
      { name: "saitti", siteId: 1, id: 1 },
      { name: "saitti", siteId: 1, id: 1 },
    ],
  },
  { name: "provideri3", providerId: 3, sites: [] },
  { name: "provideri4", providerId: 4, sites: [] },
  { name: "provideri4", providerId: 4, sites: [] },
  {
    name: "provideri4",
    providerId: 4,
    sites: [
      { name: "saitti", siteId: 1, id: 1 },
      { name: "saitti", siteId: 1, id: 1 },
      { name: "saitti", siteId: 1, id: 1 },
      { name: "saitti", siteId: 1, id: 1 },
      { name: "saitti", siteId: 1, id: 1 },
      { name: "saitti", siteId: 1, id: 1 },
    ],
  },
  { name: "provideri4", providerId: 4, sites: [] },
  { name: "provideri4", providerId: 4, sites: [] },
  { name: "provideri4", providerId: 4, sites: [] },
  { name: "provideri4", providerId: 4, sites: [] },
  { name: "provideri4", providerId: 4, sites: [] },
];
